import React, { useEffect, forwardRef } from 'react'
import './index.less'

interface PopupBottomModalProps {
  visible: boolean
  title: string
  contentClassName?: string
  titleClassName?: string
  pageClassName?: string // 当前页面根元素的类名，用于控制弹窗显示时，根元素不可滚动
  children: React.ReactNode
  onClose: () => void
  onScroll?: () => void
}

const PopupBottomModal = forwardRef(
  function Modal({
    visible = false,
    title = '提示',
    contentClassName = '',
    titleClassName = '',
    pageClassName = '',
    children,
    onClose = () => {},
    onScroll = () => {}
  }: PopupBottomModalProps, ref: React.Ref<HTMLDivElement>) {
    useEffect(() => {
      return enableScroll
    }, [])

    useEffect(() => {
      if (visible) {
        disableScroll()
      } else {
        enableScroll()
      }
    }, [visible])

    const disableScroll = () => {
      // 获取弹窗页面根元素，弹窗打开时，将根元素设为不可滚动
      if (pageClassName) {
        const rootPage: any = document.getElementsByClassName(pageClassName)[0] as HTMLElement
        !!rootPage && (rootPage.style['overflow-y'] = 'hidden')
      }
      document.body.style['overflow-y'] = 'hidden'
    }

    const enableScroll = () => {
      // 弹窗关闭时，恢复根元素可滚动
      if (pageClassName) {
        const rootPage: any = document.getElementsByClassName(pageClassName)[0] as HTMLElement
        !!rootPage && (rootPage.style['overflow-y'] = 'auto')
      }
      document.body.style['overflow-y'] = 'auto'
    }

    const preventScroll = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    return (
      <div
        className={`popup-bottom-modal-common ${visible ? 'show' : ''}`}
        onWheel={preventScroll}
        onTouchMove={preventScroll}
      >
        <div
          className={`modal ${visible ? 'show' : ''}`}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onClose()
          }}
        ></div>
        <div
          className={`content ${contentClassName} ${visible ? 'show' : ''}`}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}
          ref={ref}
          onScroll={onScroll}
        >
          {
            !!title
            &&
            <div className='title-bar'>
              <img src={require('./assets/close.png')} alt='' className='icon-close' onClick={onClose} />
              <div className={`title ${titleClassName}`}>{title}</div>
            </div>
          }
          {children}
        </div>
      </div>
    )
  }
)

export default PopupBottomModal
